export const FACET_WS = {
  surface: "#f8fafc",
  panel: "#ffffff",
  border: "rgba(15, 23, 42, 0.07)",
  borderInner: "rgba(15, 23, 42, 0.1)",
  text: "#0f172a",
  textMuted: "#64748b",
  accent: "#4f46e5",
  accentHover: "#4338ca",
  accentSoft: "rgba(79, 70, 229, 0.1)",
  segmentTrack: "#e2e8f0",
  segmentInactive: "#f1f5f9",
  headerDark: "#0f172a",
  chartGrid: "rgba(148, 163, 184, 0.35)",
} as const;
